// src/utils/floors.ts
import React from 'react';
import ReactDOMServer from 'react-dom/server';
import type { CompanyData } from './companies';

export type DirectoryCompanyItem = { name: string; logo: string };
export type DirectoryFloor = {
  name: string;
  companies: DirectoryCompanyItem[];
  index: number;
};

const getFloorNum = (s: string) => {
  const m = s.match(/^(\d+)/);
  return m ? parseInt(m[1], 10) : Number.MAX_SAFE_INTEGER;
};

// Safely turn a React SVG node into a data URL *only if* it's a valid element
const svgToDataUrl = (svg: React.ReactNode | undefined): string | undefined => {
  if (!svg) return undefined;

  // ReactNode can be string | number | boolean | null | undefined | ReactElement | ReactNode[]
  if (
    typeof svg === 'string' ||
    typeof svg === 'number' ||
    typeof svg === 'boolean'
  )
    return undefined;
  if (Array.isArray(svg)) return undefined; // keep it simple; we only support single element

  if (!React.isValidElement(svg)) return undefined;

  const markup = ReactDOMServer.renderToStaticMarkup(svg);
  return 'data:image/svg+xml;utf8,' + encodeURIComponent(markup);
};

export function buildFloorsFromCompanies(
  data: CompanyData[]
): DirectoryFloor[] {
  const map: Record<string, DirectoryFloor> = {};

  data.forEach((item) => {
    const floorName = item.floor ?? 'Ukjent etasje';
    if (!map[floorName]) {
      map[floorName] = { name: floorName, companies: [], index: 0 };
    }
    const logoUrl = item.logo ?? svgToDataUrl(item.svg) ?? '';
    map[floorName].companies.push({ name: item.name, logo: logoUrl });
  });

  return Object.values(map).sort(
    (a, b) => getFloorNum(a.name) - getFloorNum(b.name)
  );
}
